<template>
  <div class="flex items-end h-full sm:h-auto">
    <div class="flex-1">
      <slot name="h1">
        <h1 class="fs-40 font-medium mt-8 mb-1">{{ title }}</h1>
      </slot>

      <div class="flex items-center" v-if="rating">
        <rating :value="rating.supplier_rating" size="32" />
        <a
          href="javascript:void(0);"
          class="fs-14 font-medium text-black-light-5 underline ml-4"
          @click="onClickReview"
        >
          {{ reviewsCount }} {{ reviewsCount > 1 ? "reviews" : "review" }}
        </a>
      </div>
      <slot name="sub-title" v-else></slot>
    </div>
    <div class="flex flex-col items-end flex-none text-right mdsm:hidden">
      <offer-tag-list v-if="showOffer" />
      <slot name="price"></slot>
      <p v-if="priceBasis" class="text-black-light-5 fs-14">{{ priceBasis }}</p>
    </div>
  </div>
</template>

<script>
import get from "lodash/get";
import OfferTagList from "../Resort/OfferTagList";
import Rating from "../core/Rating";

export default {
  name: "ProductDetailHeading",
  props: ["title", "resortId", "showOffer"],
  components: {
    Rating,
    OfferTagList,
  },
  data() {
    return {
      rating: null,
      reviewsCount: 0,
      priceBasis: null,
    };
  },
  methods: {
    onClickReview(e) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $("#review-section").offset().top - 80,
        },
        1000
      );
    },
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.rating = get(response, "rating.aggregated_rating");
      this.reviewsCount = get(response, "rating.reviews_count");
      this.priceBasis = get(response, "supplier.room_rate_basis");
    });
  },
};
</script>
